import { ProductError, ProductErrorType } from '../../models';

export class PointARelierPoint {
  left: string;
  right: string;

  constructor(point: PointARelierPoint) {
    if (point) {
      this.left = point.left;
      this.right = point.right;
    }
  }
  static validate(point: PointARelierPoint, rowIndex: number): ProductError[] {
    return ProductError.validatePrimitiveTypes(point, ['left', 'right']) //
      .map(error => ({ ...error, payload: { rowIndex } }));
  }
}

export class PointARelierData {
  points: PointARelierPoint[];

  constructor(game: PointARelierData) {
    this.points = game && game.points ? game.points.map(p => new PointARelierPoint(p)) : [];
  }

  static validate(game: PointARelierData): ProductError[] {
    const errors: ProductError[] = [];
    if (!game.points || game.points.length < 2) {
      errors.push({
        type: ProductErrorType.NOT_ENOUGH_VALUE,
        property: 'points',
        payload: 'You must at least add 2 points to link',
      });
    }
    if (game.points && game.points.length) {
      game.points
        .map((p, i) => PointARelierPoint.validate(p, i)) //
        .forEach(subError => errors.push(...subError));
    }

    return errors;
  }
}
